export enum OrdersStates {
    CREADO = 1,
    EN_CURSO = 2,
    CANCELADO = 3,
    ENTREGADO = 4,
}